const themeLightNotificationSuccess = '#197E10';

export { themeLightNotificationSuccess };
